import { type MantineThemeOverride } from '@mantine/core';

export default {
  // loader: 'bars',
  // primaryShade: 0,
  fontFamily: 'Gotham, sans-serif',
  colors: {
    red: ['#fff5f5', '#fed7d7', '#feb2b2', '#fc8181', '#f56565', '#e53e3e', '#D61D4F', '#c53030', '#952c2c', '#822727'],
    yellow: [
      '#fffff0',
      '#fefcef',
      '#faf089',
      '#f6e05e',
      '#ecc94b',
      '#d69e2e',
      '#fac214',
      '#b7791f',
      '#975a16',
      '#744210',
    ],
    black: [
      '#C1C2C5',
      '#A6A7AB',
      '#909296',
      '#5C5F66',
      '#373A40',
      '#2C2E33',
      '#010101',
      '#1A1B1E',
      '#141517',
      '#101113',
    ],
    orange: [
      '#FFDAC4',
      '#FFCEB0',
      '#FFC19D',
      '#FFB588',
      '#FDA873',
      '#FC9B5D',
      '#F98D44',
      '#F77F22',
      '#D76E1C',
      '#B75D16',
    ],

    magenta: [
      '#FFEBEC',
      '#FED8DA',
      '#FBC4C8',
      '#F8B0B6',
      '#F59CA4',
      '#F08792',
      '#EB7281',
      '#E45B70',
      '#DE425F',
      '#D61D4F',
    ],

    chrome: [
      '#FEEEC9',
      '#FEE8B7',
      '#FDE2A4',
      '#FDDC90',
      '#FCD67A',
      '#FBCF63',
      '#FBC946',
      '#FAC214',
      '#D9A810',
      '#BA8F0C',
    ],
  },
  // defaultRadius: 16,
  primaryColor: 'orange',
  radius: {
    xl: 16,
    lg: 12,
    md: 10,
    sm: 8,
    xs: 5,
  },
  buttonShadow: '0px 4px 4px rgba(0, 0, 0, 0.20)',

  components: {
    Input: {
      styles: () => ({
        input: {
          background: '#FFFFFF',
          borderRadius: '14px',
          // boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.15)',
          padding: '15px 16px',
          height: '60px',
          minWidth: '90%',
          fontSize: '16px',
          color: '#010101',
          fontWeight: 500,
        },
        // wrapper: {
        //   paddingBottom: '15px'
        // }
      }),
    },
    InputWrapper: {
      styles: () => ({
        label: {
          color: '#D61D4F',
          paddingBottom: '5px',
          fontSize: '12px',
        },
      }),
    },
  },
} as unknown as MantineThemeOverride;
